import { STATIC_URL } from './app';

export const OPENGRAPH_IMAGE_SIZE = { width: 1200, height: 630 };

const DISCOVERY_BASE = `${STATIC_URL}/og`;
export const OPENGRAPH_COMMUNITIES_IMAGE = `${DISCOVERY_BASE}/communities-discovery-og.jpg`;
export const OPENGRAPH_EVENTS_IMAGE = `${DISCOVERY_BASE}/events-discovery-og.jpg`;
export const OPENGRAPH_SESSIONS_IMAGE = `${DISCOVERY_BASE}/sessions-discovery-og.jpg`;
export const OPENGRAPH_GUIDES_IMAGE = `${DISCOVERY_BASE}/guides-discovery-og.jpg`;
